'use strict';

module.exports = bail;

function bail(err) {
  if (err) {
    throw err;
  }
}



//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/bail/index.js
// module id = 1822
// module chunks = 7